var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-crf',{attrs:{"crfId":"tbFrmInterviewConsentForm","crfTitle":"Interview Consent Form"}})
}
var staticRenderFns = []

export { render, staticRenderFns }